import { atom, useAtom, useAtomValue } from "jotai";
import { useMemo } from "react";

import {
  activeDesignerThemeNameAtom,
  collapseThumbnailNavigationBar,
  darkModeAtom,
  enableConsoleAtom,
  hidePanelsAtom,
  keyboardShortcutsVisibleAtom,
  previewAuthAtom,
  showAiIndicatorsAtom,
} from "./applicationSettingsAtoms.ts";

// Re-exporting here to reduce churn after it got moved to designer-auth.
// There's about 40 uses across 6 packages.
export { useFeatureSwitch } from "@skilitics/designer-auth/state";

export const useHidePanels = () => useAtom(hidePanelsAtom);

export const useKeyboardShortcutsVisible = () => useAtom(keyboardShortcutsVisibleAtom);

export const usePreviewAuth = () => useAtom(previewAuthAtom);

export const useDarkMode = () => useAtom(darkModeAtom);

export const useEnableConsole = () => useAtom(enableConsoleAtom);

export const useShowAiIndicators = () => useAtom(showAiIndicatorsAtom);

export const useActiveDesignerThemeName = () =>
  useAtomValue(useMemo(() => atom((get) => (get(darkModeAtom) ? "dark" : get(activeDesignerThemeNameAtom))), []));

export const useCollapseThumbnailNavigationBar = () => useAtom(collapseThumbnailNavigationBar);
